import Translate from "@casino/legacy/client/shared/i18n/Translate";
import NextLink from "@casino/legacy/client/shared/NextLink";
import Button from "@casino/legacyUi/Button";
import DepositToPlayButton from "./DepositToPlayButton";
import Container from "./styles/Container";

type Props = { gameHref: string };

const DepositToPlay: FC<Props> = ({ gameHref }) => (
  <Container>
    <DepositToPlayButton />
    <NextLink href={gameHref}>
      <Button variant="ghost" fullWidth size="xs">
        <p className="text-xs text-white">
          <Translate id="general.open_the_game" />
        </p>
      </Button>
    </NextLink>
    <p className="text-sm/6 text-foreground" />
  </Container>
);

export default DepositToPlay;
